import React, { useEffect, useRef, useState } from 'react';
import TMC from '@autonomic/browser-sdk';
import ConfirmationDialog from '@au/core/lib/components/objects/ConfirmationDialog';
import AuInput from '@au/core/lib/components/elements/AuInput';
import AutoIntl from '@au/core/lib/components/elements/AutoIntl';
import Spinner from '@au/core/lib/components/elements/Spinner';
import { createResponseAlertMessage } from '@au/core/lib/components/objects/AlertMessage';
import styles from '../css/components/sync_conversion_rule_dialog.module.scss';

const DialogSubTitles = ({ fetching, conversionRule = {} }) => {
  const { id, sourceMessageName, releaseStageName } = conversionRule;
  const subTitles = [
    { key: 'Id:', value: id },
    { key: 'Source Message Name:', value: sourceMessageName },
    { key: 'Release Stage Name:', value: releaseStageName },
  ];
  const items = subTitles.map(({ key, value }) => {
    return (
      <div key={key}>
        <span className={styles.subheader_title}>{key}</span>
        <span className={styles.subheader_value}>{value}</span>
      </div>
    );
  });

  return <div className={styles.subheader}>{fetching ? <Spinner className={styles.spinner} /> : items}</div>;
};

const SyncConversionRuleDialog = ({ onConfirm, onCancel, syncConfig }) => {
  const { syncId, sourceLiveId, sourceEnv, allowedEnvs = [] } = syncConfig;
  const [targetEnv, setTargetEnv] = useState(allowedEnvs[0]);
  const [conversionRule, setConversionRule] = useState();
  const [fetching, setFetching] = useState(true);

  const endpointRef = useRef(null);
  if (endpointRef.current === null) {
    endpointRef.current = new TMC.services.TelemetryDefinition().syncConfigs;
  }

  useEffect(() => {
    let cancelled = false;
    endpointRef.current
      .getRuleById(sourceEnv, sourceLiveId)
      .then((resp) => {
        if (!cancelled) setConversionRule(resp.data);
        setFetching(false);
      })
      .catch(createResponseAlertMessage);
    return () => {
      cancelled = true;
    };
  }, [sourceLiveId, sourceEnv]);

  return (
    <ConfirmationDialog
      headerClassName={styles.header}
      bodyClassName={styles.body}
      titleId='au.telemetry.sync.dialog.title'
      confirmDisplayId='au.entity.proceed'
      onConfirm={() => onConfirm(syncId, targetEnv)}
      onCancel={onCancel}
    >
      <DialogSubTitles conversionRule={conversionRule} fetching={fetching} />

      <div className={styles.description}>
        <AutoIntl displayId='au.telemetry.sync.dialog.desc' tag='span' values={{ b: (text) => <b>{text}</b> }} />

        <div className={styles.radio_container}>
          {allowedEnvs.map((env) => (
            <AuInput
              key={env}
              className={styles.radio}
              name='environment'
              type='radio'
              caption={env}
              checked={env === targetEnv}
              onChange={() => setTargetEnv(env)}
            />
          ))}
        </div>
      </div>
    </ConfirmationDialog>
  );
};

export default SyncConversionRuleDialog;
